import { RecordStatus } from '../../../../models'

const STATUS_MAP: Record<string, number> = {
    not_resolved: RecordStatus.NOT_RESOLVED,
    unpaid: RecordStatus.NOT_RESOLVED,

    paid: RecordStatus.PAID,
    cancelled: RecordStatus.CANCELLED,
    previously_paid: RecordStatus.PREVIOUSLY_PAID,

    no_show: RecordStatus.NO_SHOW,
    no_record: RecordStatus.NO_SHOW,
    'no show or no record': RecordStatus.NO_SHOW,
    not_found: RecordStatus.NO_SHOW,

    too_old: RecordStatus.TOO_OLD,
    non_commissionable: RecordStatus.NON_COMMISSIONABLE,

    'ownership change or bankrupt': RecordStatus.BANKRUPTCY,
    'ownership change or bankruptcy': RecordStatus.BANKRUPTCY,

    foreign_payment: RecordStatus.FOREIGN_PAYMENT,
    pending_payment: RecordStatus.PENDING_PAYMENT,
    duplicate_payment: RecordStatus.DUPLICATE_PAYMENT,

    unknown: RecordStatus.UNKNOWN,
    duplicate: RecordStatus.DUPLICATE_RECORD,

    system_generate: RecordStatus.SYSTEM_GENERATE,
    returned_payment: RecordStatus.RETURNED_PAYMENT,
    unknown_deposit: RecordStatus.UNKNOWN_DEPOSIT,
    overpayment: RecordStatus.OVERPAYMENT,

    needs_review: RecordStatus.NEEDS_REVIEW,
    currency_review: RecordStatus.CURRENCY_REVIEW,
    inactive: RecordStatus.INACTIVE,

    refund: RecordStatus.REFUND,
    refunded: RecordStatus.REFUND,

    fees: RecordStatus.FEES,
}

function normalizeStatus(status: string): string {
    return status.trim().toLowerCase().replace(/\s+/g, ' ')
}

export function extractStatus(status: string): string {
    const key = normalizeStatus(status)
    const mapped = STATUS_MAP[key]

    return mapped !== undefined ? mapped.toString() : ''
}
